module.exports = __webpack_public_path__ + "static/media/Money.87a2c8a6.svg";